import './card.css'
import React from "react";
import {Row, Col} from 'react-bootstrap';

function TableCard(props) {
  const getHeaderColumn = (row) => {
    const headColumn = props.metadata.columns.find(x => x.HeaderColumn);
    if (headColumn) {
      return <div className="card-header">
        {mapColValue(row, headColumn)}
      </div>
    }
    return null;
  }

  const mapColValue = (row, col) => {
    if (col.Cell) {
      return col.Cell({original: row});
    }
    let result = row;
    col.accessor.split('.').forEach(x => {
      result = result[x] ? result[x] : '';
    });
    return result;
  }

  const mapCol = (row, col) => {
    return (
      <Row key={col.Header}>
        <Col sm={3} md={3}>
          <b>{col.Header}:</b>
        </Col>
        <Col sm={9} md={9}>
          {mapColValue(row, col)}
        </Col>
      </Row>
    );
  }

  const footerColumns = props.metadata &&
    props.metadata.columns
    .filter(x => x.Header === 'Opção');
  const header = getHeaderColumn(props.data);
  return (
    <article>
      <div className="card-box">
        {header ? header : null}
        {props.metadata &&
          props.metadata.columns.filter(x => !x.HeaderColumn)
          .filter(x => x.Header !== 'Opção')
          .map(x => mapCol(props.data, x))}
      </div>
      {footerColumns.length > 0 &&
        <div>
          {footerColumns.map(x => mapColValue(props.data, x))}
        </div>
      }
    </article>
  )
}

export default TableCard



// WEBPACK FOOTER //
// ./src/component/Card/TableCard/TableCard.js